import { useMemo } from 'react';
import { FormState } from '@app/lib/form/contracts/FormState';
import { PurchaseTransportInsuranceResult } from '@app/service/eshop/transport/actions/purchaseTransportInsurance';
import { ProductDataPurpose } from '@app/domain/model/eshop/transport/ProductDataPurpose';
import { ProductDataTerritories } from '@app/domain/model/eshop/transport/ProductDataTerritories';
import { MtplPurpose } from '@app/domain/model/eshop/transport/MtplPurpose';
import { CriterionSubgroupCode } from '@app/domain/model/eshop/transport/CriterionSubgroupCode';
import { CriterionOption } from '@app/domain/model/eshop/transport/CriterionOption';

export function useTransportWizardComputedValues(
    formState: FormState<PurchaseTransportInsuranceResult>,
    mtplPurposes: Nullable<ProductDataPurpose>,
    mtplTerritories: Nullable<ProductDataTerritories>,
    findOption: (code: CriterionSubgroupCode, value: string) => Nullable<CriterionOption>,
) {
    const ownerAge = useMemo(() => {
        return findOption(CriterionSubgroupCode.OwnerAge, formState.data?.formData.ownerAge ?? '');
    }, [findOption, formState.data?.formData.ownerAge]);

    const experienceOtherDrivers = useMemo(() => {
        return findOption(
            CriterionSubgroupCode.ExperienceOtherDrivers,
            formState.data?.formData.experienceOtherDrivers ?? '',
        );
    }, [findOption, formState.data?.formData.experienceOtherDrivers]);

    const territory = useMemo(() => {
        return mtplTerritories?.territories.find(territory => territory.code === formState.data?.formData.territory);
    }, [formState.data?.formData.territory, mtplTerritories?.territories]);

    const selectedPurpose = useMemo(() => {
        return mtplPurposes?.purposes.find(purpose => purpose.code === formState.data?.formData.purposeOfTheVehicle);
    }, [formState.data?.formData.purposeOfTheVehicle, mtplPurposes?.purposes]);

    const isCascoPresent = useMemo(() => {
        if (
            formState.data?.formData.insuranceDuration === '12' &&
            formState.data?.formData.purposeOfTheVehicle === MtplPurpose.Default
        ) {
            return true;
        }

        return false;
    }, [formState.data?.formData]);

    return {
        ownerAge,
        experienceOtherDrivers,
        territory: territory ?? null,
        selectedPurpose: selectedPurpose ?? null,
        isCascoPresent,
    };
}
